const Storage = require('utils/storage');
const AuthConstants = require('services/auth-management/constants');
const AuthPersistence = require('services/auth-management/persistence');

module.exports = (store) => {

    Storage.subscribeStorePathWithStore(
        store,
        'signup.context',
        AuthConstants.signupContext.storageKey,
        AuthPersistence.serializeSignupContext
    );
};
